// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Defines label color variables on a class for each label color name.
 * Consumers of labels outside of their components can import this LESS file,
 * which will load up CSS variables on any element with the corresponding class
 * name (e.g. \`.green\`).
 */
.O32JaZ3LnercqC {
  --label-background-color: var(--ds-background-accent-green-subtler, #baf3db);
  --label-background-color-hovered: var(--ds-background-accent-green-subtler-hovered, #7ee2b8);
  --label-text-color: var(--ds-text-accent-green-bolder, #164b35);
}
.SK0CNhodLL0iip {
  --label-background-color: var(--ds-background-accent-green-subtle, #4bce97);
  --label-background-color-hovered: var(--ds-background-accent-green-subtle-hovered, #7ee2b8);
  --label-text-color: var(--ds-text-accent-green-bolder, #164b35);
}
.sBOFWNt53LEzs8 {
  --label-background-color: var(--ds-background-accent-green-bolder, #1f845a);
  --label-background-color-hovered: var(--ds-background-accent-green-bolder-hovered, #216e4e);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.Ok0sykV9qamqIF {
  --label-background-color: var(--ds-background-accent-yellow-subtler, #f8e6a0);
  --label-background-color-hovered: var(--ds-background-accent-yellow-subtler-hovered, #f5cd47);
  --label-text-color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.MpGzlmHqutEeeb {
  --label-background-color: var(--ds-background-accent-yellow-subtle, #e2b203);
  --label-background-color-hovered: var(--ds-background-accent-yellow-subtle-hovered, #f5cd47);
  --label-text-color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.jTVsExkmXvsXf3 {
  --label-background-color: var(--ds-background-accent-yellow-bolder, #946f00);
  --label-background-color-hovered: var(--ds-background-accent-yellow-bolder-hovered, #7f5f01);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.MRQRoEtwYOvJgX {
  --label-background-color: var(--ds-background-accent-orange-subtler, #ffe2bd);
  --label-background-color-hovered: var(--ds-background-accent-orange-subtler-hovered, #fec57b);
  --label-text-color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.VguSovIB_F6vwy {
  --label-background-color: var(--ds-background-accent-orange-subtle, #faa53d);
  --label-background-color-hovered: var(--ds-background-accent-orange-subtle-hovered, #fec57b);
  --label-text-color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.czCMk9Ro8GP2hC {
  --label-background-color: var(--ds-background-accent-orange-bolder, #b65c02);
  --label-background-color-hovered: var(--ds-background-accent-orange-bolder-hovered, #974f0c);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.JnNNmeqqcpWjr1 {
  --label-background-color: var(--ds-background-accent-red-subtler, #ffd2cc);
  --label-background-color-hovered: var(--ds-background-accent-red-subtler-hovered, #ff9c8f);
  --label-text-color: var(--ds-text-accent-red-bolder, #601e16);
}
.p35y2TU9G_jzug {
  --label-background-color: var(--ds-background-accent-red-subtle, #f87462);
  --label-background-color-hovered: var(--ds-background-accent-red-subtle-hovered, #ff9c8f);
  --label-text-color: var(--ds-text-accent-red-bolder, #601e16);
}
.DMSfTKEgBzEE9g {
  --label-background-color: var(--ds-background-accent-red-bolder, #ca3521);
  --label-background-color-hovered: var(--ds-background-accent-red-bolder-hovered, #ae2a19);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.VguX_gNPpHjA0h {
  --label-background-color: var(--ds-background-accent-purple-subtler, #dfd8fd);
  --label-background-color-hovered: var(--ds-background-accent-purple-subtler-hovered, #b8acf6);
  --label-text-color: var(--ds-text-accent-purple-bolder, #352c63);
}
.qwKVdRgveDh0ST {
  --label-background-color: var(--ds-background-accent-purple-subtle, #9f8fef);
  --label-background-color-hovered: var(--ds-background-accent-purple-subtle-hovered, #b8acf6);
  --label-text-color: var(--ds-text-accent-purple-bolder, #352c63);
}
.Hp_NHzC8sIeSAE {
  --label-background-color: var(--ds-background-accent-purple-bolder, #6e5dc6);
  --label-background-color-hovered: var(--ds-background-accent-purple-bolder-hovered, #5e4db2);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.VgSlhgsCSUpsWH {
  --label-background-color: var(--ds-background-accent-blue-subtler, #cce0ff);
  --label-background-color-hovered: var(--ds-background-accent-blue-subtler-hovered, #85b8ff);
  --label-text-color: var(--ds-text-accent-blue-bolder, #09326c);
}
.FtGK23aljJ8XHN {
  --label-background-color: var(--ds-background-accent-blue-subtle, #579dff);
  --label-background-color-hovered: var(--ds-background-accent-blue-subtle-hovered, #85b8ff);
  --label-text-color: var(--ds-text-accent-blue-bolder, #09326c);
}
.ov1Dwy8ASp21H4 {
  --label-background-color: var(--ds-background-accent-blue-bolder, #0c66e4);
  --label-background-color-hovered: var(--ds-background-accent-blue-bolder-hovered, #0055cc);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.Dnhhu2Solz_jDT {
  --label-background-color: var(--ds-background-accent-teal-subtler, #c1f0f5);
  --label-background-color-hovered: var(--ds-background-accent-teal-subtler-hovered, #8bdbe5);
  --label-text-color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.YeJmDZgByMt5xl {
  --label-background-color: var(--ds-background-accent-teal-subtle, #60c6d2);
  --label-background-color-hovered: var(--ds-background-accent-teal-subtle-hovered, #8bdbe5);
  --label-text-color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.hyssrNLxd4Py4d {
  --label-background-color: var(--ds-background-accent-teal-bolder, #1d7f8c);
  --label-background-color-hovered: var(--ds-background-accent-teal-bolder-hovered, #206b74);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.WCpY0nP4NNp0QA {
  --label-background-color: var(--ds-background-accent-lime-subtler, #D3F1A7);
  --label-background-color-hovered: var(--ds-background-accent-lime-subtler-hovered, #b3df72);
  --label-text-color: var(--ds-text-accent-lime-bolder, #37471f);
}
.l_g3CVW3Hi5J1i {
  --label-background-color: var(--ds-background-accent-lime-subtle, #94c748);
  --label-background-color-hovered: var(--ds-background-accent-lime-subtle-hovered, #b3df72);
  --label-text-color: var(--ds-text-accent-lime-bolder, #37471f);
}
._1kfSVnkih9GGUD {
  --label-background-color: var(--ds-background-accent-lime-bolder, #5b7f24);
  --label-background-color-hovered: var(--ds-background-accent-lime-bolder-hovered, #4c6b1f);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.ZnQEiK5xQlQkBR {
  --label-background-color: var(--ds-background-accent-magenta-subtler, #fdd0ec);
  --label-background-color-hovered: var(--ds-background-accent-magenta-subtler-hovered, #f797d2);
  --label-text-color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.TZaO9K0u9uVzdL {
  --label-background-color: var(--ds-background-accent-magenta-subtle, #e774bb);
  --label-background-color-hovered: var(--ds-background-accent-magenta-subtle-hovered, #f797d2);
  --label-text-color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.DZFtGB0F8DOLgl {
  --label-background-color: var(--ds-background-accent-magenta-bolder, #ae4787);
  --label-background-color-hovered: var(--ds-background-accent-magenta-bolder-hovered, #943d73);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.PUFZkKHLtTRmBR {
  --label-background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  --label-background-color-hovered: var(--ds-background-accent-gray-subtler-hovered, #b3b9c4);
  --label-text-color: var(--ds-text-accent-gray-bolder, #091e42);
}
.v0SJuasoB54A3p {
  --label-background-color: var(--ds-background-accent-gray-subtle, #8590a2);
  --label-background-color-hovered: var(--ds-background-accent-gray-subtle-hovered, #b3b9c4);
  --label-text-color: var(--ds-text-accent-gray-bolder, #091e42);
}
.vWzIssf6wL_hGQ {
  --label-background-color: var(--ds-background-accent-gray-bolder, #626f86);
  --label-background-color-hovered: var(--ds-background-accent-gray-bolder-hovered, #44546f);
  --label-text-color: var(--ds-text-inverse, #ffffff);
}
.ck7WIkiUSpZGM2 {
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  min-width: 48px;
  max-width: 100%;
  height: 32px;
  margin-bottom: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0) 12px;
  overflow: hidden;
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--label-background-color, var(--ds-skeleton, #091e420f));
  color: var(--label-text-color, var(--ds-text, #172b4d));
  font-size: 14px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 32px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.body-color-blind-mode-enabled .ck7WIkiUSpZGM2:not(.iCVnlhnGuhmZsT),
.body-color-blind-mode-enabled ~ div .ck7WIkiUSpZGM2:not(.iCVnlhnGuhmZsT) {
  padding-left: 36px;
}
.body-color-blind-mode-enabled .ck7WIkiUSpZGM2:not(.iCVnlhnGuhmZsT)::before,
.body-color-blind-mode-enabled ~ div .ck7WIkiUSpZGM2:not(.iCVnlhnGuhmZsT)::before {
  content: '';
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  width: 24px;
  height: 24px;
  border-radius: var(--ds-border-radius-100, 3px);
}
.GzIyitdSM_OdFA {
  width: 100%;
}
.rJFnovrcSqz0vD:hover {
  background-color: var(--label-background-color-hovered, var(--ds-skeleton, #091e420f));
  cursor: pointer;
}
.rJFnovrcSqz0vD:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .rJFnovrcSqz0vD:focus {
  outline-color: -webkit-focus-ring-color;
}
.rJFnovrcSqz0vD:focus .mac.firefox {
  outline-color: AccentColor;
}
`, ""]);
// Exports
export var green_light = `O32JaZ3LnercqC`;
export var green = `SK0CNhodLL0iip`;
export var green_dark = `sBOFWNt53LEzs8`;
export var yellow_light = `Ok0sykV9qamqIF`;
export var yellow = `MpGzlmHqutEeeb`;
export var yellow_dark = `jTVsExkmXvsXf3`;
export var orange_light = `MRQRoEtwYOvJgX`;
export var orange = `VguSovIB_F6vwy`;
export var orange_dark = `czCMk9Ro8GP2hC`;
export var red_light = `JnNNmeqqcpWjr1`;
export var red = `p35y2TU9G_jzug`;
export var red_dark = `DMSfTKEgBzEE9g`;
export var purple_light = `VguX_gNPpHjA0h`;
export var purple = `qwKVdRgveDh0ST`;
export var purple_dark = `Hp_NHzC8sIeSAE`;
export var blue_light = `VgSlhgsCSUpsWH`;
export var blue = `FtGK23aljJ8XHN`;
export var blue_dark = `ov1Dwy8ASp21H4`;
export var sky_light = `Dnhhu2Solz_jDT`;
export var sky = `YeJmDZgByMt5xl`;
export var sky_dark = `hyssrNLxd4Py4d`;
export var lime_light = `WCpY0nP4NNp0QA`;
export var lime = `l_g3CVW3Hi5J1i`;
export var lime_dark = `_1kfSVnkih9GGUD`;
export var pink_light = `ZnQEiK5xQlQkBR`;
export var pink = `TZaO9K0u9uVzdL`;
export var pink_dark = `DZFtGB0F8DOLgl`;
export var black_light = `PUFZkKHLtTRmBR`;
export var black = `v0SJuasoB54A3p`;
export var black_dark = `vWzIssf6wL_hGQ`;
export var label = `ck7WIkiUSpZGM2`;
export var colorless = `iCVnlhnGuhmZsT`;
var _1 = `GzIyitdSM_OdFA`;
export { _1 as "label--fullwidth" };
var _2 = `rJFnovrcSqz0vD`;
export { _2 as "label--hoverable" };
export default ___CSS_LOADER_EXPORT___;
